import { useTranslation } from 'react-i18next';
import Button from 'src/components/Button';
import './style.scoped.css';
import cancerStore, { CancerStore } from 'src/stores/CancerStore';
import { observer } from 'mobx-react-lite';
import iconCheck from 'src/assets/checked_primary3.svg';
import { goBack } from 'src/utils';
import zigZagImg from 'src/assets/zig_zag.svg';

interface PaymentCanerSuccessNoMoneyProps {
  cancerStore?: CancerStore;
}
const PaymentCanerSuccessNoMoneyObserver = observer(
  ({ cancerStore }: PaymentCanerSuccessNoMoneyProps) => {
    const { t } = useTranslation();
    const _handleGoHome = () => {
      goBack();
    };
    return (
      <div className="screen-container bg-background">
        <div className="primaryHeader">
          <div className="h-14" />
          <div className="checkIconContainer">
            <img src={iconCheck} className="iconCheck" />
          </div>
          <div className="h-8" />
          <div className="text-surface text-base leading-5 text-center">
            {t('cancer_pay_success')}
          </div>
          <div className="h-48" />
        </div>
        <div className="infoBlock">
          <img src={zigZagImg} className="zigZagImg" />
          <div className="infoBlockContent">
            <div className="smallTitle mb-2">{t('contract_info')}</div>
            <div className="line" />
            <div className="py-5">
              <div className="smallTitle4 text-onSurfaceVariant">
                {t('contract_number')}
              </div>
              <div className="bodyText4 text-onSurface">
                {cancerStore.policyNumber}
              </div>
            </div>
            <div className="line" />
            <div className="py-5">
              <div className="smallTitle4 text-onSurfaceVariant">
                {t('ycbh_number')}
              </div>
              <div className="bodyText4 text-onSurface">
                {cancerStore.applNo}
              </div>
            </div>
          </div>
        </div>
        <div className="bottomButtonBlockWithoutBg">
          <Button
            text={t('go_home')}
            onClick={_handleGoHome}
            extraClassName={'w-full'}
          />
        </div>
      </div>
    );
  }
);

const PaymentCanerSuccessNoMoney = () => (
  <PaymentCanerSuccessNoMoneyObserver cancerStore={cancerStore} />
);
export default PaymentCanerSuccessNoMoney;
